<section class="py-5" id="features">
  <div class="container px-5 my-5">
    {{ Idproduct }}
  </div>
</section>
